export default __webpack_public_path__ + "static/media/gemercik.fa830b75.png";